import { Config, Mode } from './src/types';

export default {
  defaultLocale: 'eng',
  htmlUrl: 'https://han.apertium.org/',
  apyURL: 'https://han.apertium.org/apy',
  //apyURL: 'http://localhost:2737',

  defaultMode: Mode.Dictionary,
  enabledModes: new Set([Mode.Dictionary]),
  translationChaining: true,

  subtitle: 'Hän',
  subtitleColor: 'rgb(145, 56, 49)',

  stringReplacements: {
    '{{maintainer}}': "<a href='https://wiki.apertium.org/wiki/Apertium' target='_blank' rel='noopener'>Apertium</a>",
    '{{more_languages}}': "<a href='https://beta.apertium.org' rel='noreferrer'  target='_blank'>beta.apertium.org</a>",
  },
  showMoreLanguagesLink: false,
} as Config;
